import { Typography } from "@material-ui/core"

const Singer = (props) => {

  return ( <>
    <Typography>
      We work with a talented lineup of vocalists, each bringing their own unique style. While we can’t guarantee a specific singer, you can definitely let us know what kind of vibe you’re looking for—smooth and soulful, energetic and fun, deep and dramatic—and we’ll match your song with the best fit!
    </Typography>
  </> )
}

export default Singer
